import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class PanelHeader extends React.Component {
	/**
	 *
	 * @param props
	 */
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	/**
	 *
	 */
	render() {
		const { className } = this.props;
		const classes = classNames({ 'panel-header': true });
		return <header className={`${classes} ${className}`}>{this.props.children}</header>;
	}
}

PanelHeader.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

PanelHeader.defaultProps = {
	className: ''
};
